import { named, withDependencies, optional } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import type { IContextProviderServiceConfig, IContextProviderServiceDefinition } from './contextProviderService'
import { ContextProviderServiceDefinition } from './contextProviderService'
import { createContextProviderService } from './contextProviderServiceImpl'
import { BuilderContextProvidersAttachedStoreSymbol } from '../symbols'
import { name } from '../symbols'
import type { BuilderContextProvidersPageConfig, ICompChangeStore } from '../types'

export const ContextProviderService = withDependencies(
	[named(PageFeatureConfigSymbol, name), optional(BuilderContextProvidersAttachedStoreSymbol)],
	(
		pageFeatureConfig: BuilderContextProvidersPageConfig,
		store?: ICompChangeStore
	): ServiceProvider<
		IContextProviderServiceDefinition,
		(ops: ServiceFactoryOpts<IContextProviderServiceConfig>) => any
	> => {
		return {
			definition: ContextProviderServiceDefinition,
			impl: ({ config }) => createContextProviderService(config, store),
			config: {
				compIdToContextsMap: pageFeatureConfig.compIdToContextsMap,
			},
		}
	}
)

export const NoopContextProviderService = withDependencies(
	[],
	(): ServiceProvider<
		IContextProviderServiceDefinition,
		(ops: ServiceFactoryOpts<IContextProviderServiceConfig>) => any
	> => {
		// This service is used in every component, some components do not belong to a page (such as main_MF) and should be ignored,
		// since the service api forbid calling useService for an undefined service definition we must provide a noop implementation
		// for those skipped components (we are not allowed to use if statements inside the React component wrapper
		return {
			definition: ContextProviderServiceDefinition,
			impl: ({ config }) => createContextProviderService(config),
			config: {
				compIdToContextsMap: {},
			},
		}
	}
)
